import { Button } from "~/atoms/button";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";

interface Props {
  html: string;
  expand?: boolean;
}

export function ClampHtml({ html, expand = false }: Props) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(expand);
  const [isClamped, setIsClamped] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setExpanded(expand);
  }, [expand]);

  useEffect(() => {
    const element = contentRef.current;
    if (!element) return;

    const computedStyle = getComputedStyle(element);
    let lineHeight: number;
    if (computedStyle.lineHeight === "normal") {
      const fontSize = parseFloat(computedStyle.fontSize);
      lineHeight = fontSize * 1.2;
    } else {
      lineHeight = parseFloat(computedStyle.lineHeight);
    }
    if (!lineHeight || isNaN(lineHeight)) {
      lineHeight = 16 * 1.2;
    }
    const lines = element.scrollHeight / lineHeight;
    setIsClamped(lines > 3);
  }, [html]);

  return (
    <>
      <div
        ref={contentRef}
        className={`font-sans text-sm ${
          isClamped && !expanded ? "line-clamp-3" : ""
        }`}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
      />

      <div className="flex justify-center" hidden={!isClamped}>
        <Button variant="link" onClick={() => setExpanded(!expanded)}>
          {expanded
            ? t(($) => $.commons.buttons.collapse)
            : t(($) => $.commons.buttons.expand)}
        </Button>
      </div>
    </>
  );
}
